import { create } from 'zustand';
import { RendererStats } from '../utils/renderer-stats';

interface PerfStatsState {
  stats: RendererStats | null;
  setStats: (s: RendererStats | null) => void;
}

export const usePerfStatsStore = create<PerfStatsState>((set) => ({
  stats: null,
  setStats: (s) => set({ stats: s }),
}));
